import * as deviceUtils from "util/device";

export const showOSSettings = () => window.app.showOSSettings();

export const isCurrentDeviceRegistered = (pushNotificationsConfiguredUserDevices) =>
    Object.keys(pushNotificationsConfiguredUserDevices).some(
        (deviceIndex) => pushNotificationsConfiguredUserDevices[deviceIndex].idDevice === deviceUtils.getDeviceId(),
    );

export const isPushEnabled = () => window.pushNotifications.isOnlyEnabled();

export const getTokenPush = () => window.pushNotifications.getTokenPush();

export const firebaseUnregister = () => window?.pushNotifications?.firebaseUnregister();

export const askPermission = () => {
    window.app.askPermission();
};
export const TIMEOUT_GET_TOKEN = 15000;
export const TIMEOUT_IS_ENABLED = 10000;

export const withTimeout = (promise) => {
    let timeoutId;
    const timeoutPromise = new Promise((_, reject) => {
        timeoutId = setTimeout(() => {
            reject(new Error(`Timeout of ${TIMEOUT_GET_TOKEN}`));
        }, TIMEOUT_GET_TOKEN);
    });
    return Promise.race([promise, timeoutPromise]).finally(() => {
        clearTimeout(timeoutId);
    });
};

export const waitForEnabled = (timeout) =>
    new Promise((resolve, reject) => {
        let intervalId;

        const timeoutId = setTimeout(() => {
            clearInterval(intervalId); // Detenemos la verificación
            reject(new Error(`Timeout: El permiso no se habilitó en ${TIMEOUT_IS_ENABLED}ms.`));
        }, timeout || TIMEOUT_IS_ENABLED);

        intervalId = setInterval(async () => {
            try {
                const status = await isPushEnabled();
                if (status && status.enabled) {
                    clearInterval(intervalId); // Detenemos la verificación
                    clearTimeout(timeoutId); // Desactivamos el temporizador de fallo
                    resolve(true);
                }
                // Si no, no hacemos nada y el intervalo volverá a verificar en 1 segundo.
            } catch (error) {
                clearInterval(intervalId);
                clearTimeout(timeoutId);
                reject(error);
            }
        }, 1000); // Revisa el estado cada 1000ms (1 segundo)
    });
